module.exports = __webpack_public_path__ + "img/joinus-12.05d51366.png";